import { ApiService } from '../../../types/api';
import type { CreatePlatformCustomerPayload } from '../types/api';
import type { Customer } from '../types/customer';

export interface PlatformCustomerApiContract {
  create(payload: CreatePlatformCustomerPayload): Promise<Customer>;
}

/**
 * spark-api `PlatformCustomerController` (`/internal/v1`): customers pushed to the platform via
 * Ignite, unlike the DB-only customers v2 upsert. Sibling routes (e.g. update) belong here too.
 */
export class PlatformCustomerApi extends ApiService implements PlatformCustomerApiContract {
  public create(payload: CreatePlatformCustomerPayload): Promise<Customer> {
    return this.api.proxy({
      method: 'POST',
      path: '/internal/v1/create-platform-customer',
      payload,
    });
  }
}
